import React, { Component } from 'react';
import classnames from 'classnames';
import ReactLoading from 'react-loading';

import './RedirectModal.css';

import {getRedirectableRequests, updateResponseRedirect} from './RedirectModalAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import RedirectableRequestInnerList from './RedirectableRequestInnerList';
import RedirectableTopicOuterList from './RedirectableTopicOuterList';

class RedirectModal extends Component {

  static defaultProps = {
    toggleRedirectModal : () => {
      console.error("toggleRedirectModal props not deliveried to RedirectModal");
    },
    selectedQuestion : null,
  }

  state = {
    innerTopic : null,
    outerTopic : null,
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { show } = nextProps;
    const currentShow = this.props.show;
    const { innerTopic } = this.state;
    const { outerTopic } = this.state;

    if (innerTopic !== nextState.innerTopic || outerTopic !== nextState.outerTopic) {
      return true;
    }

    if (show === currentShow) {
      return false;
    }

    /**
     * TODO
     * Life cycle에 맞추어 수정 (애니메이션 구현방법 수정 해야함)
     */
    if (show) {
      const { callBackGetRedirectableRequests } = this;
      const { topicUpdateID } = nextProps;
      getRedirectableRequests(callBackGetRedirectableRequests, topicUpdateID);
    }

    return true;
  }

  getList = () => {

  }

  callBackGetRedirectableRequests = (response) => {
    
    const {data} = response;
    const {statusCode} = data;

    switch(statusCode) {
      case 200:
      const {property} = data;
      const {innerTopic} = property;
      const {outerTopic} = property;

      
      

      this.setState({
        innerTopic : innerTopic,
        outerTopic : outerTopic,
      })
      
      break;

      case 403:
      const {subCode} = data;
      switch(subCode) {
        case 0:
        alert("접근이 거부되었습니다.");
        break;

        case 1:
        alert("존재하지 않는 토픽입니다.");
        break;

        default:
        alert("에러가 발생하였습니다.");
      }
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
    }
  }
  callBackUpdateResponseRedirect = (response) => {
    
    const {data} = response;
    const {statusCode} = data;

    switch(statusCode) {
      case 200:
      const {property} = data;
      const {updateResponseRedirect} = this.props;

      const { redirectRequestID } = property;
      const { updateID } = property;

      updateResponseRedirect(redirectRequestID);
      break;

      case 403:
      const {subCode} = data;
      switch(subCode) {
        case 0:
        alert("접근이 거부되었습니다.");
        break;

        case 1:
        alert("존재하지 않는 리퀘스트입니다.");
        break;

        case 2:
        alert("존재하지 않는 리스폰스입니다.");
        break;

        default:
        alert("에러가 발생하였습니다.");
      }
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
    }
  }

  handleUpdateResponseRedirect = (requestID) => {
    const { callBackUpdateResponseRedirect } = this;
    const {responseUpdateID} = this.props;
    
    

    updateResponseRedirect(callBackUpdateResponseRedirect, responseUpdateID, requestID);
  }

  renderInnerRedirectableRequests = (redirectableRequests) => {
    
    const { handleUpdateResponseRedirect } = this;
    if (!redirectableRequests) {
      return (
        <ReactLoading type={"bars"} width={30} height={30} color="black" />
      );
    }
    
    return (
      <RedirectableRequestInnerList
        redirectableRequests={redirectableRequests}
        updateResponseRedirect={handleUpdateResponseRedirect}
        selectedQuestion={this.props.selectedQuestion}
        selectResponse={this.props.selectResponse}
        parentRequestId={this.props.parentRequestId} />
    );
  }
  renderOuterRedirectableRequests = (redirectableTopics) => {
    const { handleUpdateResponseRedirect } = this;
    if (!redirectableTopics) {
      return (
        <ReactLoading type={"bars"} width={30} height={30} color="black" />
      );
    }
    return (
      <RedirectableTopicOuterList
        redirectableTopics={redirectableTopics}
        updateResponseRedirect={handleUpdateResponseRedirect} />
    );
  }

  handleExitModal = (e) => {
    const { toggleRedirectModal } = this.props;
    this.setState({
      innerTopic : null,
      outerTopic : null,
    })
    toggleRedirectModal();
  }

  render() {
    // render methods
    const { renderInnerRedirectableRequests } = this;
    const { renderOuterRedirectableRequests } = this;
    const { handleExitModal } = this;

    const { show } = this.props;
    const { toggleRedirectModal } = this.props;

    const { innerTopic } = this.state;
    const { outerTopic } = this.state;

    const modalClass = classnames({
      'redirect-control-modal' : true,
      'show' : show,
      'hide' : !show,
    })
    const whiteSpaceClass = classnames({
      'redirect-modal-white-space' : show,
    })

    const renderedRequestsInner = renderInnerRedirectableRequests(innerTopic);
    const renderedTopicsOuter = renderOuterRedirectableRequests(outerTopic);

    return (
      <React.Fragment>
        <div class={whiteSpaceClass}
          onClick={handleExitModal} >
        </div>
        <div class={modalClass}>
          <div className="redirectable-list-wrapper">
            <div className="redirectable-list">
              <div className="row">
                <div className="col-sm">
                  <div className="inner-topic-wrapper">
                    <div className="inner-topic">
                      <div className="header">
                        <p> 현재 토픽 </p>
                      </div>
                      <div className="body">
                        {renderedRequestsInner}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm">
                  <div className="outer-topic-wrapper">
                    <div className="outer-topic">
                      <div className="header">
                        <p> 다른 토픽 </p>
                      </div>
                      <div className="body">
                        {renderedTopicsOuter}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
      
    );
  }
}

export default RedirectModal;